export const state = () => ({
  list: []
})

export const mutations = {
  add(state, text) {
    state.list.push({
      text,
      done: false
    })
  },
  remove(state, { todo }) {
    state.list.splice(state.list.indexOf(todo), 1)
  },
  toggle(state, todo) {
    todo.done = !todo.done
  }
}



export const actions = {

    async getStoreData ({ commit }) {      

        const data = await this.$axios(
        {
          url: 'https://apimytoggleio-dev.airship.co.uk/graphql/cached',
          method: 'post',
          data: {
            query: `
                query($domain:String, $product_active:Int, $postage_type_active:Int, $store_type_id:Int, $order_by: String){
                    Accounts(domain:$domain){

                      tag_manager_container,
                      ga_tracking_id,

                      id,
                      domain,
                      show_promotional_code_input,
                      default_domain,
                      name,
                      website,
                      privacy_policy_url,
                      terms_url,
                      contact_url,
                      page_text,
                      footer_text,
                      order_confirmation_heading,
                      order_confirmation_text,
                      toggle_fulfilment,
                      storeLive,
                      purchase_terms_active,
                      phone_number_for_orders_active,
                      purchase_terms_text,
                      custom_message_for_postal_products_active,
                      PaymentProviderAccount{
                        payment_provider_id,
                        PaymentProviderAccountConfigs{
                          payment_provider_attribute_id,
                          content
                        }
                      }, 
                      Image{
                        url
                      },
                      Consents{
                        id,
                        consent_copy,
                        is_active
                      },
                      PostageTypes(active:$postage_type_active){
                        id, 
                        max_value, 
                        max_quantity,
                        Currency{
                          id, 
                          denomination, 
                          symbol
                        }, 
                        delivery_name, 
                        price, 
                        tracked
                      }, 
                      Bundles(page:1, limit:100, active:$product_active){

                        data{
                          id,
                          price,
                          name,
                          slug, 
                          short_description, 
                          long_description, 
                          active, 
                          Image{
                            url
                          },
                          Currency{
                            id, 
                            denomination, 
                            symbol
                          },
                          PriceModifiers{
                            id,
                            description,
                            price,
                            Product{
                              id,
                              name,
                              FulfilmentMethods{
                                id,
                                name
                              }
                            }
                            
                          }
                        },
                        total,
                        per_page

                      },
                      Products(active:$product_active, store_type_id:$store_type_id, order_by:$order_by){
                        id, 
                        name,
                        webshop_order,
                        slug, 
                        short_description, 
                        long_description, 
                        active,
                        show_on_storefront,
                        stock_available,
                        sale_limit,
                        display_remaining_at,
                        CurrentExpiryConfig{
                          seconds_valid_for,
                          hard_expire_at
                        },
                        PostageTypes{
                          id, 
                          max_value, 
                          max_quantity,
                          Currency{
                            id, 
                            denomination, 
                            symbol
                          }, 
                          PostageCategory{
                            id, 
                            name

                          },
                          delivery_name, 
                          price, 
                          tracked
                        }, 
                        AutomaticPromotions(limit:10, page:1){
                          data{
                            id,
                            display_text,
                            display_text_long
                          },
                          total,
                          per_page
                        },
                        ValidityRules{
                          rule,
                          validity_rule_type_id
                        },
                        Image{
                          url
                        }, 
                        ProductType{
                          id,
                          name
                        }, 
                        FulfilmentMethods{
                          id,
                          name
                        }, 
                        PriceModifiers{
                          id, 
                          price, 
                          description, 
                          Currency{
                            id, 
                            denomination, 
                            symbol}
                          }
                        }
                      },
                      AccountStyles{name, Components{id, name, ThemeElements{id, element_reference, ThemeElementStyles(domain:$domain){id, property, value}}}},
                      AccountFonts(domain:$domain){font_library},
                }
              `,
            variables: {
                domain: 'localhost',
                product_active: 1,
                postage_type_active: 1,
                store_type_id:1,
                order_by: 'webshop_order'
            }
          }
        }

      );


    const post = data.data;


  return {post};

    },
}